var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[(!_vm.auth.isPartner && !_vm.auth.isLightPartner)?_c('dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }